import React from 'react';

const MastersAbroadBottomline = () => {
  const benefits = [
    {
      title: "Career-Focused Financial Strategy",
      description: "A well-planned Masters education investment considers not just the costs, but the career trajectory and earning potential post-graduation, ensuring optimal ROI on your educational investment."
    },
    {
      title: "Strategic Loan Management",
      description: "Thoughtful planning allows for optimizing loan structures, potentially securing better interest rates, repayment terms aligned with career paths, and tax benefits in both home and host countries."
    },
    {
      title: "Opportunity Cost Reduction",
      description: "Careful financial planning considers and minimizes the opportunity costs associated with leaving the workforce, helping maintain financial stability during your academic journey."
    },
    {
      title: "Long-term Wealth Acceleration",
      description: "A Masters degree abroad often provides access to global job markets with higher compensation, creating potential for accelerated wealth creation when supported by proper financial planning."
    }
  ];

  return (
    <div className="w-full bg-gradient-to-br from-[#113262] to-[#1C52A0] py-12 px-8">
      <div className="max-w-6xl w-full mx-auto px-4 sm:px-6 lg:px-8 py-4 md:py-6 lg:py-8">
        <div className="text-center mb-16">
          <h2 className="text-white text-2xl md:text-3xl lg:text-4xl font-bold mb-4">
            Bottomline: Strategic Masters Abroad Financial Planning
          </h2>
          <div className="w-24 h-1 bg-[#F49611] mx-auto mt-4"></div>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-16">
          {benefits.map((benefit, index) => (
            <div key={index} className="relative">
              {/* Decorative number */}
              <div className="absolute -left-8 top-0 text-6xl font-bold text-white opacity-30">
                {index + 1}
              </div>
              
              {/* Content */}
              <div className="relative">
                <div className="flex items-start space-x-4">
                  {/* Vertical line decoration */}
                  <div className="hidden md:block w-1 h-full bg-gradient-to-b from-[#F49611] to-transparent"></div>
                  
                  <div className="flex-1">
                    <h3 className="text-[#F49611] text-xl font-semibold mb-4">
                      {benefit.title}
                    </h3>
                    <p className="text-white/80 text-base leading-relaxed">
                      {benefit.description}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MastersAbroadBottomline;